import { render, staticRenderFns } from "./ContentViewSettingsAction.vue?vue&type=template&id=bb243696&scoped=true&"
import script from "./ContentViewSettingsAction.vue?vue&type=script&lang=js&"
export * from "./ContentViewSettingsAction.vue?vue&type=script&lang=js&"
import style0 from "./ContentViewSettingsAction.vue?vue&type=style&index=0&id=bb243696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb243696",
  null
  
)

export default component.exports